import React from "react";
import "./style.css";



const Jumbotron = () => (
  <div className="jumbotron jumbotron-fluid backgroundImage">
    <div className="container text-center">
      <h1 className="display-4 text">REACT CLICKY GAME</h1>
      <p className="lead text">Click on any image to earn points, but don't click on any more than once!</p>
    </div>
  </div>
  );
  export default Jumbotron;